import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Offices from './components/Offices';

const offices = (props,{ t }) => (
  <Container>
    <Offices {...props} />
  </Container>
);

offices.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(offices);
